import ajax from '../utils/request'

const loginApi = {
  /********************************登陆管理*********************************** */
  // 登陆
  login(params) {
    return ajax({
      url: '/login',
      type: 'post',
      params: params
    })
  },
  // 登陆验证
  verify(params) {
    return ajax({
      url: '/verify',
      type: 'post',
      params: params
    })
  },
  // 刷新token
  refreshToken(params) {
    return ajax({
      url: '/refresh',
      type: 'get',
      params: params
    })
  },
  // 登出
  logout(params) {
    return ajax({
      url: '/logout',
      type: 'post',
      params: params
    })
  },
}
export default loginApi
